"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  quote: "\"\"New Chapter Property Solutions\" made selling my house quick and easy. I got a fair cash offer and closed in just over a week!\"\"\"\"",
  author: "Jane D.",
  location: "Satisfied Seller",
  avatarImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/testimonial_avatar_jane.png"
}, {
  id: 2,
  quote: "Their team was transparent and professional. No hidden fees, and they covered all closing costs.",
  author: "Mike P.",
  location: "Happy Client",
  avatarImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579273/img/testimonial_avatar_mike.png"
}];
export default function HomeownerSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="homeowner-success-stories" className="bg-background py-24 md:py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-6">
            Homeowner Success Stories
          </h2>
          <div className="h-1 w-20 bg-primary mx-auto rounded-full opacity-80"></div>
        </div>

        <div className="max-w-5xl mx-auto relative px-4 md:px-16">
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, index) => <CarouselItem key={testimonial.id} data-index={index}>
                  <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12 py-8 md:py-12">
                    <div className="shrink-0 relative">
                      <div className="absolute inset-0 rounded-full border border-primary/40 scale-110"></div>
                      <SafeHydrate><Avatar className="size-24 md:size-32 border-4 border-background shadow-sm">
                        <AvatarImage src={testimonial.avatarImg} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="bg-muted text-muted-foreground text-2xl font-serif">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                    </div>

                    <div className="flex-1 text-center md:text-left space-y-8">
                      <Quote className="size-10 text-primary/20 mx-auto md:mx-0 rotate-180" />
                      <blockquote className="text-2xl md:text-4xl font-serif italic text-foreground leading-relaxed tracking-tight">
                        "{testimonial.quote}"
                      </blockquote>
                      <div className="space-y-1">
                        <div className="font-bold text-lg text-foreground tracking-wide uppercase text-sm">
                          {testimonial.author}
                        </div>
                        <div className="text-muted-foreground text-sm font-medium">
                          {testimonial.location}
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="flex justify-center gap-4 mt-8 md:mt-0 md:block">
              <CarouselPrevious className="static md:absolute md:top-1/2 md:-left-4 md:-translate-y-1/2 size-12 border-[1px] border-foreground/20 bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-none" />
              <CarouselNext className="static md:absolute md:top-1/2 md:-right-4 md:-translate-y-1/2 size-12 border-[1px] border-foreground/20 bg-transparent text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 shadow-none" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}